/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect } from "react";
import "./Card.css";
import loc from "../../images/loc.svg";
import harr from "../../images/harr.svg";
import cancel from "../../images/cancel.svg";
import Skeleton from "react-loading-skeleton";
import wifi1 from "../../images/wifi1.svg";
import park1 from "../../images/park1.svg";
import wallet from "../../images/wallet.svg";
import { useNavigate } from "react-router-dom";
import Enlarge from "../Enlarge/Enlarge";
import RatingComponent from "../RatingComponent/Rating";
import GMap from "../../services/GoogleMap";
import { SaleServices } from "../../services/supplier";
import edit from "../../images/edit.svg";
import ampool from "../../images/am-pool.svg";
import amair from "../../images/am-air.svg";
import amspa from "../../images/am-spa.svg";
import rectangle from "../../images/card-rec.svg";
import bed from "../../images/am-bed.svg";
import { buyItem } from "../../services/web3Services";
import { toast } from "react-toastify";
import location from "../../images/location.svg";
import calender from "../../images/calender.svg";
import arroww from "../../images/arroww.svg";
import wifi from "../../images/am-wifi.svg";
import parking from "../../images/am-parking.svg";
import { countDays, getDateFormat } from "../../utils/date";
import star5 from "../../images/5star.svg";
import HotelAmenities from "../Amenities/HotelAmenities";
import AmenitiesSymbol from "../Amenities/AmenitiesSymbol";
import { getTokenUrl } from "../../services/web3Services";
const mapStyle = {
  // minWidth: "400px",
  minHeight: "250px",
  height: "500px",
  
};
const Card = ({
  id,
  images,
  name,
  item,
  roomsLeft,
  ratings,
  isCancel,
  reviews,
  star,
  attributes,
  room,
  dateValue,
  search,
  isNotAvailable,
}) => {
  const [enlarge1, setEnlarge1] = useState(false);
  const [showMoreDescription, setShowMoreDescription] = useState(false);
  const navigate = useNavigate();
  const [ratt, setRatt] = useState("Good");
  const [cordinates, setCordinates] = useState({
    lat: parseFloat(44),
    lng: parseFloat(43),
  });
  const handleRatt = (ratings) => {
    let x = Math.round(ratings);
    if (x > 1 && x <= 2) {
      setRatt("Ok");
    } else if (x > 2 && x <= 3) {
      setRatt("Good");
    } else if (x > 3 && x <= 4) {
      setRatt("Superb");
    } else if (x > 4 && x <= 5) {
      setRatt("Excellent");
    }
  };
  const handleEnlarge1 = (e) => {
    // if (item.hasOwnProperty("locationCordinates")) {
    //   console.log( item?.locationCordinates?.latitude , "Latitude");
    //   setCordinates({
    //     lat: item?.locationCordinates?.latitude,
    //     lng: item?.locationCordinates?.longitude,
    //   });
    // }
    setEnlarge1(true);
  };

  console.log(isNotAvailable)

  useEffect(() => {
    handleRatt(ratings);
  }, [ratings]);
  return (
    <>
      <Enlarge
        open={enlarge1}
        setOpen={setEnlarge1}
        noEl
        element={<GMap coordinates={{ lat:item?.locationCordinates?.latitude,
          lng:item?.locationCordinates?.longitude}} mapStyle={mapStyle} />}
      />
      <div
        className="flex mobile:h-[260px] my-6 bg-white  card !p-0"
        style={{ height: "fit-content" }}
      >
        <img
          src={images[0]?.url}
          onClick={() => navigate(`/hotel/${id}?search=${search}`)}
          className="cursor-pointer mobile:w-[260px] mobile:min-w-[260px] xl:min-w-[330px] xl:w-[330px] h-[full] object-cover mngHtlDispNone1"
        />
        <img
          src={images[0]?.url}
          onClick={() => navigate(`/hotel/${id}?search=${search}`)}
          className="cursor-pointer mngHtlDispNone w-full h-[270px] object-cover"
        />
        <div className="flex flex-col card1 justify-center items-start p-3 xl:pb-4 xl:pt-4 !w-full">
          <div className="flex items-center justify-start">
            <p
              onClick={() => navigate(`/hotel/${id}?search=${search}`)}
              className="cursor-pointer hhead mr-4 mb-0"
            >
              {name || <Skeleton />}
            </p>
            <div className="hotel-star-rating">{star} Star Hotel</div>
          </div>
          <div className="flex items-center gap-x-3 mt-3">
            <img src={loc} className="h-[16px]" />
            <p className="hadd mb-0">
              {item.city + (item.city && ", ") + item.country || <Skeleton />}
            </p>
            <p
              onClick={handleEnlarge1}
              className="see cursor-pointer w-[60px] mb-0"
            >
              See Map
            </p>
            <img className="seemap  mr-[6px]" src={harr} />
          </div>
          {/* <div className="line mt-3 mb-1"></div> */}
          <div className="items-center mt-4 flex md:hidden xl:flex">
            {reviews?.length > 0 ? (
              <div className="justify-center items-center ml-2 text-xs text-gray-500">
                <RatingComponent rating={item.starRatings} readOnly /> {reviews}{" "}
                reviews
              </div>
            ) : (
              <div className="justify-center items-center mb-1 text-xs text-gray-500">
                No guest reviews available yet
              </div>
            )}
          </div>
          <p className="fontdesc text-xs font-normal mt-1 whitespace-pre-wrap">
            <div
              dangerouslySetInnerHTML={{
                __html:
                  item?.description.length > 98
                    ? item?.description?.slice(0, 99) + "..."
                    : item?.description,
              }}
            ></div>
            {/* {item?.description.length > 98
              ? item?.description.replace(/<(?:.|\s)*?>/g, "").slice(0, 99) +
                "..."
              : item?.description}
              */}
            {item?.description && item.description.length > 100 && (
              <span
                onClick={() => navigate(`/hotel/${id}?search=${search}`)}
                className=" cursor-pointer fontdesc font-normal text-xs text-[#2F69FF]"
              >
                Read More
              </span>
            )}
          </p>

          <div className=" nonedisp1 mt-8 mobile:flex hidden">
            <p
              onClick={handleEnlarge1}
              className="cursor-pointer fontdesc font-normal text-sm text-[#2F69FF] ml-40"
            >
              See Map
            </p>
            <img className="seemap11" src={harr} />
          </div>
          <div className="line1 mt-3 mb-0"></div>
          <div className="makeflex w-[100%] flex justify-between ">
            {isCancel && <img src={cancel} width={117} height={21} />}
            <div className="flex items-center gap-x-4 w-[100%]  justify-center">
              {/* <AmenitiesSymbol attributes={item.attributes}/> */}
              <HotelAmenities length={5} attributes={item.attributes} />
            </div>
          </div>
          <div className="line1 mt-6 mb-0"></div>
        </div>
        <div className="card2 flex flex-col overflow-hidden p-0 !justify-between cardm min-w-[180px] lg:min-w-[240px] xl:!w-[240px] lg:!w-[200px] relative">
          {item.hasOwnProperty("inventory_price") ? (
            <div className="pl-4 justify-center mobile:p-6 flex flex-col mobile:items-end gap-y-1 yashmargin">
              <div className="fontbasic hidden mobile:block text-xs text-gray-500">
                Starting from
              </div>
              <div className="cost1 flex ">
                ${item?.pricing.minPrice || <Skeleton className="!w-16" />}
              </div>
              <div className="flex">
                Total $
                {(item?.pricing.sum * room).toFixed(2) || (
                  <Skeleton className="!w-12" />
                )}
              </div>
            </div>
          ) : (
            item.hasOwnProperty("marketplace_price") && (
              <div className="pl-4 justify-center mobile:p-6 flex flex-col mobile:items-end gap-y-1 yashmargin">
                <div className="fontbasic hidden mobile:block text-xs text-gray-500">
                  Starting from
                </div>
                <div className="cost1 flex ">
                  ${item?.marketplace_price || <Skeleton className="!w-16" />}
                </div>
                <div className="flex">
                  Total $
                  {(item?.marketplace_price).toFixed(2) || (
                    <Skeleton className="!w-12" />
                  )}
                </div>
              </div>
            )
          )}
          <div className="flex flex-col justify-end gap-y-2 items-center">
            {/* show when less than 10 */}
            {/* {roomsLeft && (
              <p className="rl !text-xs">
                Hurry up! only {roomsLeft || <Skeleton />} rooms left
              </p>
            )} */}
            {!isNotAvailable ? (
              <button
                onClick={() => navigate(`/hotel/${id}?search=${search}`)}
                className="flex items-center gap-x-2 choosebtn mobile:!w-full w-[200px] justify-center"

              >
                Choose Room <img src={harr} className="filter-white" />
              </button>
            ) : (
              <button>
                <p className="text-xs text-center font-thin leading-3 ">- No Rooms Available -</p>
              </button>

            )}


          </div>
        </div>
      </div>
    </>
  );
};

export const BookingData = ({
  data,
  loading,
  setLoading,
  setViewMore,
  viewMore,
}) => {
  let navigate = useNavigate();

  console.log(data.hotel_id, "Hotel Id")

  const buyThisItem = async () => {
    try {
      setLoading(true);
      if (!JSON.parse(sessionStorage.getItem("userDetails")).userId) {
        return toast.error("Please login!");
      }
      console.log(data?.priceOnSale)
      await buyItem(data?.saleId, data?.priceOnSale)
        .then(async (res) => {
          await SaleServices.buyItem(
            data?.saleId,
            data?.user_id,
            res.from,
            data?.user_id,
            data?.priceOnSale,
            data.bookingId,
            res?.transactionHash
          );
          setLoading(false);
          toast.success("Successfully bought.");
          navigate("/manageBooking");
        })
        .catch((err) => {
          console.log(
            "err ",
            err?.message.includes(
              "execution reverted: ERC20: transfer amount exceeds balance"
            )
          );
          console.log(
            "err?.message: ",
            err?.message.includes("execution reverted: seller cannot buy")
          );
          if (err?.message.includes("execution reverted: seller cannot buy")) {
            return toast.error("Seller cannot buy.");
          }
          if (
            err?.message.includes(
              "execution reverted: ERC20: transfer amount exceeds balance"
            )
          ) {
            return toast.error("Insufficient Funds!");
          }
          toast.error(err?.message);
          setLoading(false);
        });
    } catch (error) {
      setLoading(false);
    }
  };
  return (
    <>
      {new Date(data.nftRef.checkInDate) > new Date() && (
        <div
          className="flex mobile:h-[273px] my-6 bg-white card !p-0"
          style={{ height: "fit-content" }}

        >
          <div className="grid gap-2 grid-cols-2 mobile:grid-cols-3">
            <div className="flex flex-col  mx-auto col-span-2 mobile:col-span-1">
              <div className="p-2 mobile:p-0">
                <img
                  className="w-full h-[273px] object-cover mx-auto m-0"
                  src={data?.hotel_id?.images[0].url}
                  alt="location2"
                />
              </div>
            </div>
            <div className="flex flex-col my-2 mobile:my-4 pl-4 mobile:p-0  ">
              <p className="fontdesc text-2xl font-bold text-gray-900 hotelhead h-auto ">
                {data?.hotel_id.name}
              </p>
              <div className="flex mt-2">
                <img src={location} className="h-4" alt="location" />
                <label className=" text-sm font-normal text-gray-600 pl-2 textsm">
                  {data?.hotel_id.city}, {data?.hotel_id.country}
                </label>
              </div>
              <div className="flex  mt-10">
                <img src={calender} className="h-4" alt="location1" />
                <label className="text-sm font-normal text-gray-600 pl-2 pr-4 textsm">
                  {getDateFormat(data?.nftRef.fromDate)} -{" "}
                  {getDateFormat(data?.nftRef.toDate)}
                </label>
              </div>
              <div className="text-gray-600  mt-5">
                <img src={cancel} width={117} height={21} className="mt-1" />
              </div>
              <div className="flex mt-4 gap-4 place-items-center">
                {/* hotelamenities */}
                <HotelAmenities
                  length={3}
                  attributes={data.hotel_id.attributes}
                />
              </div>
            </div>
            <div className="flex flex-col items-start p-4">
              <p className="text-right text-2xl mobile:text-4xl mr-10  ">
                ${data?.priceOnSale}{" "}
              </p>
              <p className="text-right text-sm mobile:text-xs text-black mr-10">
                Selling Price
              </p>
              <p
                className="text-sm text-center mt-5 font-normal text-gray-400 textsm"
                onClick={() =>
                  getTokenUrl(
                    data?.nftRef.contractAddress,
                    data?.nftRef.tokenId
                  )
                }
              >
                Token ID :{" "}
                <span className="bg-gray-300 py-1 px-4 rounded-full text-xs textcolorid">
                  {data?.nftRef.tokenId}
                </span>
              </p>
              <p
                onClick={() =>
                  getTokenUrl(
                    data?.nftRef.contractAddress,
                    data?.nftRef.tokenId
                  )
                }
                className="text-sm my-3 text-center mobile:4 font-normal text-gray-600   textsm"
              >
                Booked by :{" "}
                <span className="text-gray-400 textsm ">
                  {data &&
                    data?.nftRef &&
                    (data.nftRef?.ownerTrail[
                      data.nftRef?.ownerTrail?.length - 1
                    ].currentOwner).slice(0, 6)}
                  ...
                  {data.nftRef?.ownerTrail[
                    data.nftRef?.ownerTrail?.length - 1
                  ].currentOwner.slice(-4)}
                </span>
              </p>
              {data &&
                data?.user_id ==
                JSON.parse(sessionStorage.getItem("userDetails")).userId ? (
                <button
                  className="mt-4 mb-4 w-full flex justify-center items-center
                                  border-2 border-[#292931] overflow-hidden hover:bg-gray-800 hover:border-1 hover:text-gray-900 text-white font-bold py-2 px-8 rounded-full  bg-[#292931]"
                  height={60}
                  onClick={() => {
                    navigate(
                      `/sales?sale-room=${data.bookingId}&room=${data.room_id._id}&edit-listing=true`
                    );
                  }}
                >
                  <img src={edit} className="w-5 h-5" />

                  <span className="fontdesc !text-sm font-medium p-1 !m-0 text-white textsell1">
                    Edit Listing
                  </span>
                </button>
              ) : (
                //   <button
                //     className="buy flex items-center  justify-center mt-4 w-full overflow-hidden hover:bg-gray-100 hover:border-1 hover:text-gray-900 text-white font-bold py-1 px-2 rounded-full  buttonClr"
                //     height={60}
                //     onClick={() => buyThisItem()}
                //   >
                //     <span className=" flex place-items-center  fontdesc text-lg font-medium p-2 textsell1">
                //       Buy This Room
                //       <img src={arroww} alt="" className="ml-4 fill-white" />
                //     </span>
                //   </button>
                <button
                  className="buy flex items-center  justify-center mt-2 w-full overflow-hidden hover:bg-gray-100 hover:border-1 hover:text-gray-900 text-white font-bold py-1 px-1 rounded-full  buttonClr"
                  height={60}
                  // onClick={() =>
                  //     navigate(
                  //         `/saleRoom/${data?.room_id._id}/`
                  //     )
                  // }
                  onClick={() => buyThisItem()}
                >
                  <span className=" flex place-items-center  fontdesc text-lg md:text-xs lg:text-medium font-medium p-2 textsell1">
                    Buy This Hotel
                    <img src={arroww} alt="" className="ml-4 fill-white" />
                  </span>
                </button>
              )}
            </div>
          </div>

          {/* view more */}
          {viewMore == data?._id && (
            <div>
              <div className="flex mt-7 px-4 content-center justify-between flex-wrap">
                <div className="flex items-center my-5  mobile:w-1/2 mr-14 flex-wrap">
                  <p className="fontdesc text-2xl font-bold    text-gray-900 hotelhead ">
                    {data?.hotel_id.name}
                  </p>
                  <span className="text-gray-500 rounded-full border-2  border-gray-500 p-2 text-sm">
                    {data?.hotel_id.starRatings} Star Hotel
                  </span>
                </div>
                <div className="flex items-center ml-3">
                  <img src={star5} alt="location9" />

                  <p className="fontdesc text-sm font-normal mr-3 text-gray-800 ml-4 fontsmin">
                    {data?.hotel_id.guestRatings} Users Recieved
                  </p>
                </div>
              </div>
              <div className="flex flex-wrap px-4 items-center">
                <div className="mobile:basis-1/2">
                  <p className=" mobile:w-1/2  text-sm whitespace-pre-wrap">
                    {data?.hotel_id.description}
                  </p>

                  <p className="fontdesc text-lg  font-semibold text-gray-900 mt-4">
                    Amenities
                  </p>
                  <div className="flex flex-wrap    justify-items-start mt-3 w-1/2 ml-3">
                    <div className=" flex ml-4  mb-8 iconsm">
                      <span>
                        {" "}
                        <img
                          src={rectangle}
                          width={18}
                          height={16}
                          alt="rectangle"
                        />
                      </span>
                      <span className=" ml-4 text-sm">
                        {data?.room_id.roomArea}{" "}
                        {data?.room_id?.roomAreaUnit
                          ? data?.room_id?.roomAreaUnit
                          : "sq. ft."}
                      </span>
                    </div>
                    {data?.hotel_id.attributes.hasOwnProperty("hasFreeWifi") &&
                      data?.hotel_id.attributes.hasFreeWifi && (
                        <div className="flex  ml-4 mb-8 iconsm">
                          <span>
                            {" "}
                            <img src={wifi} alt="wifi" />
                          </span>
                          <span className="ml-4 text-sm">Wifi</span>
                        </div>
                      )}
                    {data?.hotel_id.attributes.hasOwnProperty(
                      "hasFreeParking"
                    ) &&
                      data?.hotel_id.attributes.hasFreeParking && (
                        <div className="flex ml-4 mb-8 iconsm">
                          <span>
                            {" "}
                            <img src={parking} alt="wifi" />
                          </span>
                          <span className="  ml-4 text-sm">Free-Parking</span>
                        </div>
                      )}

                    {data?.hotel_id.attributes.hasOwnProperty("hasKingBed") &&
                      data?.hotel_id.attributes.hasFullBoard && (
                        <div className="flex  ml-4 mb-8 iconsm">
                          <span>
                            {" "}
                            <img src={bed} alt="bed" />
                          </span>
                          <span className="text-sm  ml-4">King Bed</span>
                        </div>
                      )}
                    {data?.hotel_id.attributes.hasOwnProperty("hasPool") &&
                      data?.hotel_id.attributes.hasPool && (
                        <div className="flex  ml-4 mb-8 iconsm">
                          <span>
                            {" "}
                            <img src={ampool} alt="bed" />
                          </span>
                          <span className="text-sm  ml-4">Pool</span>
                        </div>
                      )}
                    {data?.hotel_id.attributes.hasOwnProperty(
                      "hasAirConditioning"
                    ) &&
                      data?.room_id.attributes.hasAirConditioning && (
                        <div className="flex  ml-4 mb-8 iconsm">
                          <span>
                            {" "}
                            <img src={amair} alt="bed" />
                          </span>
                          <span className="  ml-4 text-sm">
                            Air Conditioning
                          </span>
                        </div>
                      )}
                    {data?.hotel_id.attributes.hasOwnProperty("hasFreeWifi") &&
                      data?.hotel_id.attributes.hasFreeWifi && (
                        <div className="flex  ml-4 mb-8 iconsm">
                          <span>
                            {" "}
                            <img src={wifi} alt="bed" />
                          </span>
                          <span className="text-sm  ml-4">Free Wifi</span>
                        </div>
                      )}
                    {data?.hotel_id.attributes.hasOwnProperty("hasSpa") &&
                      data?.hotel_id.attributes.hasSpa && (
                        <div className="flex  ml-4 mb-8 iconsm">
                          <span>
                            {" "}
                            <img src={amspa} alt="bed" />
                          </span>
                          <span className="text-sm  ml-4">Spa</span>
                        </div>
                      )}

                    <div className="flex  ml-4 mb-8 iconsm">
                      <span>
                        {" "}
                        <svg
                          width="18"
                          height="17"
                          viewBox="0 0 18 17"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12.8068 7.08887C13.201 7.08985 13.5916 7.01973 13.9558 6.88257C14.32 6.7454 14.6507 6.54392 14.9286 6.28978L17.8163 3.66648C18.0446 3.45887 18.0657 3.12103 17.8481 2.90319C17.7935 2.84846 17.7273 2.80438 17.6534 2.77364C17.5795 2.74289 17.4994 2.72612 17.4182 2.72434C17.3369 2.72255 17.2561 2.73579 17.1807 2.76325C17.1052 2.79072 17.0367 2.83183 16.9792 2.8841L14.4055 5.22205C14.3191 5.30051 14.2019 5.34458 14.0798 5.34458C13.9577 5.34458 13.8405 5.30051 13.7541 5.22205C13.5745 5.0591 13.5842 4.78364 13.7635 4.62069L16.326 2.29126C16.3834 2.23904 16.4286 2.17676 16.4587 2.1082C16.4889 2.03964 16.5035 1.96622 16.5015 1.89239C16.4995 1.81857 16.4811 1.74588 16.4473 1.67872C16.4135 1.61157 16.3651 1.55135 16.305 1.50171C16.1964 1.41218 16.0548 1.36291 15.9082 1.36364C15.742 1.36375 15.5827 1.42383 15.4653 1.53069L12.9051 3.85773C12.8186 3.9362 12.7015 3.98027 12.5794 3.98027C12.4572 3.98027 12.3401 3.9362 12.2537 3.85773C12.0744 3.69478 12.0838 3.41932 12.263 3.25637L14.8255 0.927621C14.883 0.875402 14.9281 0.813124 14.9583 0.744563C14.9885 0.676001 15.003 0.602583 15.0011 0.528759C14.9991 0.454935 14.9807 0.382242 14.9469 0.315087C14.9131 0.247931 14.8647 0.187711 14.8045 0.138076C14.6959 0.0485404 14.5543 -0.000725304 14.4077 8.07158e-06C14.2416 0.000186856 14.0823 0.0602612 13.9649 0.167053L11.0791 2.79035C10.7995 3.04309 10.5779 3.34374 10.427 3.67489C10.2761 4.00604 10.199 4.36112 10.2001 4.71955V5.00012C10.2001 5.07185 10.1846 5.14289 10.1544 5.20917C10.1243 5.27545 10.08 5.33566 10.0242 5.38637L8.68875 6.60069C8.67482 6.61336 8.65828 6.62342 8.64007 6.63029C8.62186 6.63715 8.60234 6.64068 8.58262 6.64068C8.56291 6.64068 8.54339 6.63715 8.52518 6.63029C8.50697 6.62342 8.49043 6.61336 8.4765 6.60069L1.97822 0.693076C1.86607 0.591005 1.71399 0.533482 1.55529 0.533099C1.39659 0.532716 1.24419 0.589503 1.13144 0.69103C0.563287 1.20273 0.259899 1.92512 0.259899 2.77978C0.256149 4.19114 1.07218 5.81387 2.38961 7.00978L5.59412 9.92284C6.04958 10.336 6.66674 10.5681 7.3102 10.5682C7.51533 10.5683 7.71963 10.5444 7.9181 10.4973C7.96793 10.4854 8.01922 10.4793 8.07073 10.4792C8.22136 10.4792 8.36643 10.531 8.47687 10.6241L8.90401 10.9827C9.01418 11.085 9.07607 11.2224 9.07652 11.3656V11.5544C9.07542 11.9838 9.26104 12.3961 9.59292 12.7016L12.9699 15.8233L12.9733 15.8267C13.3481 16.1674 13.8565 16.3588 14.3865 16.3587C14.9165 16.3587 15.4249 16.1673 15.7996 15.8265C16.1744 15.4858 16.3849 15.0237 16.3849 14.5419C16.3848 14.06 16.1742 13.598 15.7994 13.2573L10.7375 8.65569C10.7235 8.64302 10.7125 8.62798 10.7049 8.61143C10.6974 8.59487 10.6935 8.57713 10.6935 8.55921C10.6935 8.54129 10.6974 8.52354 10.7049 8.50699C10.7125 8.49043 10.7235 8.4754 10.7375 8.46273L12.0729 7.24875C12.1286 7.19806 12.1948 7.15784 12.2677 7.13041C12.3405 7.10297 12.4186 7.08886 12.4974 7.08887H12.8068Z"
                            fill="url(#paint0_linear_1099_19402)"
                          />
                          <path
                            d="M7.31018 11.6591C6.34952 11.6573 5.42838 11.3112 4.74657 10.696L4.2268 10.2235C4.17056 10.1725 4.09436 10.1439 4.01492 10.1439C3.93548 10.1439 3.85928 10.1725 3.80304 10.2235L0.6154 13.1062C0.0472515 13.6227 -0.155632 14.3829 0.12563 15.1275C0.141372 15.1694 0.160035 15.2104 0.181507 15.2502C0.559898 15.9545 1.29418 16.3636 2.09746 16.3636C2.37371 16.3642 2.64735 16.315 2.90253 16.2188C3.1577 16.1226 3.38934 15.9813 3.58403 15.8032L7.83521 11.9202C7.8531 11.9036 7.8668 11.8837 7.87535 11.8618C7.8839 11.8399 7.88709 11.8165 7.88471 11.7934V11.7845C7.88304 11.7633 7.87665 11.7426 7.86594 11.7236C7.85522 11.7046 7.84039 11.6879 7.82234 11.6743C7.80429 11.6607 7.7834 11.6505 7.76093 11.6445C7.73845 11.6384 7.71486 11.6365 7.69157 11.639C7.56492 11.6517 7.43761 11.6585 7.31018 11.6591Z"
                            fill="url(#paint1_linear_1099_19402)"
                          />
                          <defs>
                            <linearGradient
                              id="paint0_linear_1099_19402"
                              x1="16.5613"
                              y1="16.3904"
                              x2="1.96896"
                              y2="-1.61622"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop offset="0.0245099" stop-color="#383838" />
                              <stop offset="1" stop-color="#8264F9" />
                            </linearGradient>
                            <linearGradient
                              id="paint1_linear_1099_19402"
                              x1="3.94274"
                              y1="10.1439"
                              x2="3.94274"
                              y2="16.3636"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stop-color="#383838" />
                              <stop offset="1" stop-color="#8264F9" />
                            </linearGradient>
                          </defs>
                        </svg>
                      </span>
                      <span className="text-sm ">Restauraunt</span>
                    </div>
                  </div>
                </div>
                <div className="  flex justify-end  p-4 mobile:basis-1/2">
                  <div className="w-full h-full">
                    <GMap
                      mapStyle={mapStyle}
                      coordinates={{
                        lat: data?.hotel_id?.latitude,
                        lng: data?.hotel_id?.longitude
                      }}
                    />
                  </div>
                </div>
              </div>
              <button
                onClick={() => setViewMore("")}
                className="flex px-4 text-cyan-600 font-medium "
              >
                <span className=" mx-auto text-sm my-6">View Less</span>
              </button>
              <div className="w-full relative flex pb-6 justify-center">
                <button
                  className="buybtn box-border flex items-center w-fit px-8 mx-4 justify-center overflow-hidden hover:bg-gray-100 hover:border-1 hover:text-gray-900 text-white font-bold py-1 rounded-full  buttonClr"
                  height={60}
                >
                  <p className=" flex place-items-center place-content-center fontdesc text-lg font-medium p-2 textsell1">
                    Buy This Room
                    <svg
                      className="ml-4 hover:fill-neutral-900"
                      width="20"
                      height="12"
                      viewBox="0 0 20 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M19.7719 6.48736C20.0648 6.19447 20.0648 5.71959 19.7719 5.4267L14.9989 0.65373C14.706 0.360837 14.2311 0.360837 13.9382 0.65373C13.6453 0.946624 13.6453 1.4215 13.9382 1.71439L18.1809 5.95703L13.9382 10.1997C13.6453 10.4926 13.6453 10.9674 13.9382 11.2603C14.2311 11.5532 14.706 11.5532 14.9989 11.2603L19.7719 6.48736ZM0 6.70703H19.2415V5.20703H0V6.70703Z"
                        fill="white"
                      />
                    </svg>
                  </p>
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default Card;
